import Hero from "../../frontend/components/Hero";
import CalculatorsImag1 from "../../assets/images/MortgageRepaymentCalculator.jpg";
import MortgageRepaymentCalculator from "../../frontend/components/calculators/MortgageRepaymentCalculator";

const MortgageRepaymentCalculatorsPage = () => {
  return (
    <div>
      <Hero
        title="Mortgage Repayment"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <MortgageRepaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageRepaymentCalculatorsPage;
